module.exports = __webpack_public_path__ + "img/banner_left.7a534a04.jpg";